<template>
  <div>
    <v-container>
      <Hero :data="pageData" ref="homeCTA" />
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" align="center" justify="center">
          <div
            class="text-uppercase caption mb-4 grey--text text--darken-2"
          >{{ $t('home.popular-platform') }}</div>
          <h2 class="display-1">{{ $t('home.reach-more-globel-network') }}</h2>
          <v-divider class="mt-5 mx-auto" style="max-width: 100px; border-width: 2px" />
        </v-col>
<!--        <v-col align="center" v-for="(icon, index) in socialIcons" :key="index">-->
<!--          <v-img max-width="48" aspect-ratio="1" :src="require(`../assets/social_icons/${icon}`)" />-->
<!--        </v-col>-->
      </v-row>
    </v-container>
    <v-container>
      <v-row class="relative">
        <div class="fixed d-none d-sm-block">
          <v-card class="rounded-lg" max-width="737" min-width="600" height="100%">
            <div class="d-flex pa-4 align-center justify-space-between">
              <v-img class="mr-auto flex-grow-0" src="../assets/logo.png" width="120" contain />
              <div class="place-holder mr-4"></div>
              <div class="place-holder-avatar"></div>
            </div>
          </v-card>
        </div>
        <v-col align="center" v-for="(card, i) in latestInfluencerData" :key="i" cols="6" md="3">
          <v-card elevation="12" max-width="216" class="rounded-lg mt-12">
            <v-list-item>
              <v-list-item-content>
                <v-avatar size="106" class="ma-auto">
                  <img
                    :src="card.navAvatar"
                    :alt="card.navDisplayName"
                  >
                </v-avatar>
                <v-list-item-title class="pt-6">
                  <div>{{ card.navDisplayName }}</div>
                  <div class="caption pt-3 text-capitalize">{{ card.industries[0]}}</div>
<!--                  <div class="caption font-weight-thin"><v-icon size="16">mdi-map-marker</v-icon>China</div>-->
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-card-text>
              <v-row>
                <v-col>
                  <div class="body-1 pink--text">{{ card.fans | kFormatter }}</div>
                  <div>{{ $t('common.reach') }}</div>
                </v-col>
                <v-col>
                  <div class="body-1 pink--text">{{ card.activity || 0 }}&#176;</div>
                  <div>{{ $t('common.activity') }}</div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-img
                v-for="(platform, i) in card.platforms"
                :key="i"
                class="ma-auto"
                max-width="20"
                aspect-ratio="1"
                :src="require(`../assets/social_icons/${platform}.png`)" />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-col cols="12">
        <v-img class="relative" src="../assets/world-map.png">
          <v-img
            width="16"
            class="d-absolute map-insta elevation-12"
            src="../assets/social_icons/facebook.png" />
          <v-img
            width="16"
            class="d-absolute map-youtube elevation-12"
            src="../assets/social_icons/youtube.png" />
          <v-img
            width="16"
            class="d-absolute map-zhihu elevation-12"
            src="../assets/social_icons/zhihu.png" />
          <v-img
            width="16"
            class="d-absolute map-douyin elevation-12"
            src="../assets/social_icons/douyin.png" />
          <v-img
            width="16"
            class="d-absolute map-wechat elevation-12"
            src="../assets/social_icons/weixin.png" />
          <v-img
            width="16"
            class="d-absolute map-instagram"
            src="../assets/social_icons/instagram.png" />
          <v-img
            width="16"
            class="d-absolute map-weibo elevation-12"
            src="../assets/social_icons/weibo.png" />
          <v-img
            width="16"
            class="d-absolute map-bilibili elevation-12"
            src="../assets/social_icons/bilibili.png" />
          <v-img
            width="16"
            class="d-absolute map-xiaohongshu elevation-12"
            src="../assets/social_icons/xiaohongshu.png" />
        </v-img>
      </v-col>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12"  class="text-center">
          <h2 class="display-1">{{ pageData.body[0].primary.topic1[0].text  }}</h2>
          <v-divider class="mt-2 mx-auto" style="max-width: 100px; border-width: 2px" />
        </v-col>
      </v-row>
      <v-row class="" v-for="(service, index) in pageData.body[0].items" :key="index">
        <v-col
          :order="index%2 === 0 && !$vuetify.breakpoint.mobile ? 'last' : 'first'"
          cols="12"
          md="6">
          <h3 class="title">{{ service.title1[0].text }}</h3>
          <h4 class="subtitle-1">{{ service.service_subtitle[0].text }}</h4>
          <v-chip v-for="n in service.text" color="primary" class="mr-2 mt-2" outlined>{{ n.text }}</v-chip>
        </v-col>
        <v-col
          cols="12"
          md="6"><v-img :src="service.image.url"  height="300"></v-img></v-col>
      </v-row>
    </v-container>

    <v-container v-show="false">
      <v-card>
        <v-card-title>
          <v-form ref="searchForm" style="width: 100%">
            <v-row align="center" justify="center">
              <v-col md="3" cols="12">
                <v-select
                  required
                  outlined
                  :rules="[v => !!v || 'Item is required']"
                  hide-details
                  v-model="searchForm.what"
                  :items="$t('searchForm.what')"
                  prepend-inner-icon="mdi-help"
                  :label="$t('searchForm.q1')"
                ></v-select>
              </v-col>
              <v-col md="3" cols="6">
                <v-select
                  required
                  hide-details
                  outlined
                  :rules="[v => !!v || 'Item is required']"
                  v-model="searchForm.industry"
                  :items="$t('searchForm.which')"
                  prepend-inner-icon="mdi-format-list-bulleted-type"
                  :label="$t('searchForm.q2')"
                ></v-select>
              </v-col>
              <v-col md="3" cols="6">
                <v-select
                  required
                  hide-details
                  outlined
                  :rules="[v => !!v || 'Item is required']"
                  v-model="searchForm.country"
                  :items="$t('searchForm.where')"
                  prepend-inner-icon="mdi-map-marker"
                  color="blue"
                  :label="$t('searchForm.q3')"
                ></v-select>
              </v-col>
              <v-col md="3" cols="12">
                <v-btn large block color="primary" @click="search">
                  <v-icon left>mdi-magnify</v-icon>
                  {{ $t('common.search') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-title>
        <v-card-text v-if="searchResult !=null">
          <v-row align-content="center" justify="center">
            <v-progress-circular indeterminate size="64" v-if="searching"></v-progress-circular>
            <template v-else-if="searchForm.what === 'influencer'">
              <v-col cols="12">
                <span
                  class="grey--text text--lighten-1"
                >Showing {{ searchResult.length }} preview results</span>
              </v-col>
              <v-col v-for="i in searchResult" :key="i" cols="6" md="3">
                <v-hover v-slot:default="{ hover }">
                  <v-card class :elevation="hover ? 16 : 2" @click="focus">
                    <v-card-title class="justify-center">
                      <v-avatar size="90" class="grey lighten-2">
                        <v-img :src="'https://res.cloudinary.com/twodm/image/fetch/' + i.avatar"></v-img>
                      </v-avatar>
                    </v-card-title>
                    <v-card-text class="justify-center">
                      <v-row class="justify-center" no-gutters>
                        <v-col class="text-center" cols="12">
                          <v-icon class="mr-1" color="primary">mdi-map-marker</v-icon>
                          {{ i.country }}
                        </v-col>
                        <v-col class="text-center text-capitalize" cols="12">{{ i.industry }}</v-col>
                        <v-col class="text-center" cols="12">
                          <p
                            class="headline text--primary font-weight-bold"
                          >$ {{ Math.trunc(i.amount) }}</p>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                      <v-btn icon>
                        <v-icon color="green">mdi-chat</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-hover>
              </v-col>
            </template>
            <v-container v-else-if="searchForm.what === 'job'" @click="focus">
              <briefCard :data="briefs" />
            </v-container>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <v-container>
      <v-row class="text-center" justify="center">
        <v-col cols="12">
          <h2 class="display-1">{{ $t('home.section-1.subtitle')}}</h2>
          <v-divider class="mt-2 mx-auto" style="max-width: 100px; border-width: 2px" />
        </v-col>
        <customer-story :stories="pageData.body[3].items" />
        <v-col v-for="(logo, i) in logos" :key="i" class="d-flex child-flex">
          <v-img :src="logo" width="80px" contain>
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row class="text-center">
        <v-col cols="12">
          <h1 class="heading">{{ $t('home.section-1.title')}}</h1>
          <span class="grey--text text--lighten-1">{{ $t('home.section-1.cta')}}</span>
        </v-col>
      </v-row>
      <news-grid :news-list="newsList"  />
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import faker from 'faker';
import Hero from '@/components/hero';
import briefCard from '../components/briefCard';
import CustomerStory from '../components/CustomerStory';
import NewsGrid from '../components/NewsGrid';

export default {
  components: {
    NewsGrid,
    CustomerStory,
    briefCard,
    Hero,
  },
  data: () => ({
    fields: {
      cta: null,
    },
    searchForm: {
      what: null,
      industry: null,
      country: null,
    },
    searching: false,
    items: ['Brand', 'Influencer', 'MCN/Agency'],
    searchResult: null,
    latestInfluencerData: [],
    socialIcons: [
      'bilibili.png',
      'douyin.png',
      'facebook.png',
      'instagram.png',
      'tiktok.png',
      'weibo.png',
      'weixin.png',
      'xiaohongshu.png',
      'youtube.png',
      'zhihu.png',
    ],
    form: {
      email: '',
      firstname: '',
      type: '',
      company: '',
      hs_language: localStorage.lang,
    },
    emailRules: [
      v => !!v || this.$t('naviForm.emailRequire'),
      v => /.+@.+\..+/.test(v) || this.$t('naviForm.emailValid'),
    ],
    priceSection: {
      title: null,
    },
    submissionSuccess: false,
    showSubmissionDialog: false,
    logos: [
      'https://res.cloudinary.com/twodm/image/upload/v1580691194/robobloq_x8rdfn.png',
      'https://res.cloudinary.com/twodm/image/upload/v1580691364/xmxz3d1w32zzjonntdqv.png',
      'https://res.cloudinary.com/twodm/image/upload/v1580709494/-img-gallery-66143697-1017520814_g4mssm.jpg',
      'https://res.cloudinary.com/twodm/image/upload/v1580691449/f83d86c9-2307-48c5-b343-89435b0b5335.__CR0_0_600_180_PT0_SX600_V1____yjxrmq.jpg',
      'https://res.cloudinary.com/twodm/image/upload/v1580691604/k2b4xqofhxfai2knnroo.jpg',
    ],
    briefs: [],
    pageData: '',
    newsList: [],
  }),
  methods: {
    getContent() {
      this.$prismic.client
        .getSingle('home', { lang: this.$i18n.locale })
        .then((document) => {
          this.pageData = document.data;
        });
    },
    fetchNews() {
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'news'), { lang: this.$i18n.locale },
      ).then((document) => {
        this.newsList = document.results;
      });
    },
    getLatestInfluencers() {
      axios.get(`${process.env.VUE_APP_TRACKING_ROOT}/influencers/latest`).then((res) => {
        this.latestInfluencerData = res.data;
      });
    },
    getBriefList() {
      this.$prismic.client
        .query([
          this.$prismic.Predicates.at('document.type', 'campaign'),
          this.$prismic.Predicates.at(
            'my.campaign.product_category',
            this.searchForm.industry,
          ),
        ])
        .then((res) => {
          this.briefs = res.results;
        });
    },
    focus() {
      this.$vuetify.goTo(this.$refs.homeCTA);
      this.$refs.emailInput.focus();
    },
    getCookie(name) {
      const match = document.cookie.match(new RegExp(`${name}=([^;]+)`));
      console.log(match);
      if (match) return match[1];
    },
    reset() {
      this.$refs.form.reset();
      this.form.company = '';
      this.form.firstname = '';
      this.form.hs_language = '';
    },
    signUp() {
      if (this.$refs.form.validate()) {
        this.showSubmissionDialog = true;
      }
    },
    search() {
      if (this.$refs.searchForm.validate()) {
        this.searching = !this.searching;
      } else {
        return;
      }
      // random generator
      const generator = (schema, min = 1, max) => {
        max = max || min;
        faker.locale = this.searchForm.country === 'CN' ? 'zh_CN' : 'en';
        return Array.from({ length: faker.random.number({ min, max }) }).map(
          () => Object.keys(schema).reduce((entity, key) => {
            entity[key] = faker.fake(schema[key]);
            return entity;
          }, {}),
        );
      };
      // schema
      const clientsSchema = {
        username: '{{internet.userName}}',
        productName: '{{image.technics}}',
        avatar: '{{internet.avatar}}',
        industry: this.searchForm.industry,
        country:
          this.searchForm.country === 'all'
            ? '{{address.countryCode}}'
            : this.searchForm.country,
        email: '{{internet.email}}',
        amount: '{{finance.amount}}',
        biz: '{{image.business}}',
      };
      this.getBriefList();
      this.searchResult = generator(clientsSchema, 6, 20);
      setTimeout(() => {
        this.searching = !this.searching;
      }, 1000);
    },
    submitForm() {
      const submitUrl = 'https://api.hsforms.com/submissions/v3/integration/submit/6517596/264eca34-05f6-4fc0-9d38-482204eb5ffc';
      axios
        .post(submitUrl, {
          fields: [
            {
              name: 'email',
              value: this.form.email,
            },
            {
              name: 'company',
              value: this.form.company,
            },
            {
              name: 'type',
              value: this.form.type,
            },
            {
              name: 'firstname',
              value: this.form.firstname,
            },
            {
              name: 'hs_language',
              value: this.form.hs_language,
            },
          ],
          context: {
            hutk: this.getCookie('hubspotutk'),
            pageUri: 'navigate.network',
            pageName: 'Navigate Home',
          },
        })
        .then((res) => {
          this.submissionSuccess = true;
          this.reset();
        });
    },
  },
  created() {
    this.getContent();
    this.fetchNews();
    this.getLatestInfluencers();
  },
};
</script>

<style>
.hero-cta {
  z-index: 1;
}
.hero-text {
  font-family: Maxwell, Noto Sans SC, serif;
  font-size: 3.5em;
  line-height: 60px;
  color: black;
}
.rounded {
  border-radius: 16px !important;
}
.relative {
  position: relative;
}
.d-absolute {
  position: absolute;
  animation: float 6s ease-in-out infinite;
}
.map-insta {
  left: 20%;
  top: 30%;
}
.map-youtube {
  left: 81%;
  top: 68%;
}
.map-wechat {
  left: 84%;
  top: 20%;
}
.map-instagram {
  left: 76%;
  top: 36%;
}
.map-weibo {
  left: 30%;
  top: 44%;
}
.map-bilibili {
  left: 50%;
  top: 18%;
}
.map-xiaohongshu {
  left: 55%;
  top: -10%;
}
.map-zhihu {
  left: 75%;
  top: 18%;
}
.map-douyin {
  left: 72%;
  top: 20%;
}
.fixed {
  position: absolute;
  right: 10%;
  height: 100%;
}
@media only screen and (max-width: 600px) {
.fixed {
  right: 0;
}
}
.place-holder {
  background-color: #F0ECFE;
  border-radius: 24px;
  height: 30px;
  width: 200px;
}
.place-holder-avatar {
  background-color: #F0ECFE;
  display: block;
  height: 30px;
  width: 30px;
  border-radius: 50%;
}
ul {
  padding: 0 !important;
}
@keyframes float {
  0% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    transform: translatey(0px);
  }
  50% {
    box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);
    transform: translatey(-5px);
  }
  100% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    transform: translatey(0px);
  }
}
</style>
